(function () {
  const storage = window.selinzaSafeStorage;
  const storageKey = "shopify-compare";
  const delimiter = ",";
  const activeClass = "active";

  function getCompare() {
    const compare = storage?.getItem(storageKey);
    if (!compare) return [];

    return compare
      .split(delimiter)
      .map((handle) => handle.trim())
      .filter(Boolean);
  }

  function setCompare(array) {
    const uniqueCompare = Array.from(new Set(array.filter(Boolean)));
    const compare = uniqueCompare.join(delimiter);

    if (uniqueCompare.length) storage?.setItem(storageKey, compare);
    else storage?.removeItem(storageKey);

    return uniqueCompare;
  }

  function updateCompare(handle) {
    const compare = getCompare();
    const indexInCompare = compare.indexOf(handle);

    if (indexInCompare === -1) compare.push(handle);
    else compare.splice(indexInCompare, 1);

    return setCompare(compare);
  }

  function updateCompareCounter() {
    const compareItemLength = getCompare().length;
    document.querySelectorAll(".compare__count").forEach((counter) => {
      counter.innerText = compareItemLength;
    });
  }

  class CompareProduct extends HTMLElement {
    constructor() {
      super();
      this.boundOnAddCompare = this.onAddCompare.bind(this);
    }

    connectedCallback() {
      if (this.compareInitialized) return;
      this.compareInitialized = true;
      this.addEventListener("click", this.boundOnAddCompare);
      this.onAddActiveClass();
      updateCompareCounter();
    }

    onAddActiveClass() {
      const compareAddedButton = this.querySelector("button");
      if (!compareAddedButton) return;

      const productHandle = compareAddedButton.dataset.productHandle;
      if (!productHandle) {
        console.error(
          "[Compare] Missing `data-product-handle` attribute. Failed to update compare."
        );
        return;
      }

      compareAddedButton.classList.toggle(
        activeClass,
        getCompare().includes(productHandle)
      );
    }

    onAddCompare(event) {
      const compareItem = this.querySelector("button");
      if (!compareItem || !compareItem.contains(event.target)) return;

      const productHandle = compareItem.dataset.productHandle;
      if (!productHandle) {
        console.error(
          "[Compare] Missing `data-product-handle` attribute. Failed to update compare."
        );
        return;
      }

      updateCompare(productHandle);
      updateCompareCounter();

      const comparePage = document.querySelector(".compare-page");
      comparePage?.classList.toggle("compare_exists", getCompare().length > 0);

      const grid = document.querySelector("[grid-compare]");
      if (grid) {
        this.closest(".product-grid-item")?.remove();
      } else {
        compareItem.classList.add("loading", "adding");
        window.setTimeout(() => {
          compareItem.classList.remove("loading");
          compareItem.classList.toggle(activeClass);
        }, 500);
        window.setTimeout(() => {
          compareItem.classList.remove("adding");
        }, 1000);
      }
    }

    getCompare() {
      return getCompare();
    }

    setCompare(array) {
      return setCompare(array);
    }

    updateCompare(handle) {
      return updateCompare(handle);
    }

    compareContains(handle) {
      return getCompare().includes(handle);
    }
  }

  if (!customElements.get("compare-item")) {
    customElements.define("compare-item", CompareProduct);
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateCompareCounter();
    bindCompareTable();
    setupCompare();
  });

  function bindCompareTable() {
    const compareTable = document.querySelector("#compare-content");
    if (!compareTable || compareTable.dataset.compareBound === "true") return;

    compareTable.dataset.compareBound = "true";
    compareTable.addEventListener("click", (event) => {
      const removeButton = event.target.closest?.(".cp_remove--button");
      if (!removeButton) return;

      const productHandle = removeButton.dataset.productHandle;
      if (!productHandle) {
        console.error(
          "[Compare] Missing `data-product-handle` attribute. Failed to update compare."
        );
        return;
      }

      updateCompare(productHandle);
      updateCompareCounter();

      const productId = removeButton.dataset.pid;
      compareTable.querySelectorAll("td").forEach((cell) => {
        if (cell.dataset.pid === productId) cell.remove();
      });

      document
        .querySelector(".compare-page")
        ?.classList.toggle("compare_exists", getCompare().length > 0);
    });
  }

  function setupCompare() {
    const compare = getCompare();
    const comparePage = document.querySelector(".compare-page");

    comparePage?.classList.toggle("compare_exists", compare.length > 0);
    if (!compare.length || !comparePage) return;

    const requests = compare.map((handle) => {
      const productTileTemplateUrl =
        "/products/" + encodeURIComponent(handle) + "?view=compare";

      return fetch(productTileTemplateUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Compare product request failed: ${response.status}`);
          }
          return response.text();
        })
        .catch((error) => {
          console.error("[Compare]", error);
          return "";
        });
    });

    Promise.all(requests).then((responses) => {
      const compareProductCards = responses.filter(Boolean).join("");
      if (!compareProductCards) return;

      const compareHTML = new DOMParser().parseFromString(
        compareProductCards,
        "text/html"
      );

      const mappings = [
        [".product-grid-item__thumbnail", ".cp_prd-thumb"],
        [".cp_prd-price", ".cp_prd-price"],
        [".cp_prd-availability", ".cp_prd-availability"],
        [".cp_prd_description", ".cp_prd_description"],
        [".cp_prd-brand", ".cp_prd-brand"],
        [".cp_prd_buy--proudct", ".cp_prd_buy--proudct"],
      ];

      mappings.forEach(([sourceSelector, destinationSelector]) => {
        const destination = comparePage.querySelector(destinationSelector);
        if (!destination) return;

        compareHTML.querySelectorAll(sourceSelector).forEach((item) => {
          destination.appendChild(item);
        });
      });
    });
  }
})();
